module.exports = __webpack_public_path__ + "img/art15.90a1f120.png";